"use client";

import { motion, useScroll, useTransform } from "framer-motion";
import React, { useRef } from "react";

const AnimationSection = () => {
  const scrollSection = useRef(null);
  const { scrollYProgress } = useScroll({
    target: scrollSection,
    offset: ["start 55%", "start start"],
  });
  const height = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);
  return React.createElement(
    "div",
    {
      className:
        "absolute left-8 right-auto top-[10%] h-3/4 w-0.5 bg-black/15 md:left-[2.4375rem]",
    },
    React.createElement(motion.div, {
      ref: scrollSection,
      className: "bg-black",
      style: { height },
    }),
  );
};

export function Layout121() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="grid grid-cols-1 items-start gap-y-8 md:grid-cols-2 md:gap-x-12 lg:gap-x-20">
          <div>
            <p className="mb-3 font-semibold md:mb-4">Integration</p>
            <h2 className="rb-5 mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">
              Plug in what you already use
            </h2>
          </div>
          <div className="relative">
            <AnimationSection />
            <div className="grid grid-cols-[max-content_1fr] gap-x-6 lg:gap-x-10">
              <div className="relative flex flex-col items-center justify-start py-10">
                <div className="relative z-10 -mt-4 bg-white px-2 py-4 md:px-4">
                  <img
                    src="/images/icons/spine-icon.png"
                    alt="Relume icon 1"
                    className="size-12"
                  />
                </div>
              </div>
              <div className="py-10">
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                  The spine
                </h6>
                <p>
                  A structural layer that organizes data across all your tools
                  intelligently.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-[max-content_1fr] gap-x-6 lg:gap-x-10">
              <div className="relative flex flex-col items-center justify-start py-10">
                <div className="relative z-10 -mt-4 bg-white px-2 py-4 md:px-4">
                  <img
                    src="/images/icons/spine-icon.png"
                    alt="Relume icon 2"
                    className="size-12"
                  />
                </div>
              </div>
              <div className="py-10">
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                  The hub
                </h6>
                <p>
                  Central control that routes and secures your data with
                  enterprise-grade protection.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-[max-content_1fr] gap-x-6 lg:gap-x-10">
              <div className="relative flex flex-col items-center justify-start py-10">
                <div className="relative z-10 -mt-4 bg-white px-2 py-4 md:px-4">
                  <img
                    src="/images/icons/spine-icon.png"
                    alt="Relume icon 3"
                    className="size-12"
                  />
                </div>
              </div>
              <div className="py-10">
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                  AI agents
                </h6>
                <p>
                  Automated insights, brainstorming, and action built into your
                  connected workflow.
                </p>
              </div>
            </div>
            <div className="grid grid-cols-[max-content_1fr] gap-x-6 lg:gap-x-10">
              <div className="relative flex flex-col items-center justify-start py-10">
                <div className="relative z-10 -mt-4 bg-white px-2 py-4 md:px-4">
                  <img
                    src="/images/icons/spine-icon.png"
                    alt="Relume icon 4"
                    className="size-12"
                  />
                </div>
              </div>
              <div className="py-10">
                <h6 className="mb-3 text-md font-bold leading-[1.4] md:mb-4 md:text-xl">
                  Your choice
                </h6>
                <p>
                  Bring your own AI model or use ours—IntegrateWise works either
                  way.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
